export const constants = {
	selector: {
		dependentSelectBox: 'data-dependentselectbox',
	},
}
